// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'admin/core/store';
import {
    Item,
    Translate,
} from '@plesk/ui-library';
import {
    DashboardItemContainer,
    ItemAdditionalDescription,
} from 'admin/dashboard/containers/items/Styles';
import CardHeader from 'admin/dashboard/components/CardHeader';

export type Ipv4ItemProps =
    ReturnType<typeof mapStateToProps>;

export const Ipv4Item: React.FC<Ipv4ItemProps> = ({
    stats,
}) => (
    <DashboardItemContainer>
        <Item
            description={(
                <ItemAdditionalDescription>
                    <Translate content="dashboard.of" />
                    &nbsp;
                    <span>{stats.total}</span>
                </ItemAdditionalDescription>
            )}
            view="card"
            title={
                <CardHeader>
                    <Translate content="dashboard.cards.ipv4" params={{ usage: stats.used }} />
                </CardHeader>
            }
        />
    </DashboardItemContainer>
);

const mapStateToProps = (state: RootState) => ({
    stats: state.dashboard.data.ipv4,
});

export default connect(mapStateToProps)(Ipv4Item);
